/**
 * Sets number on the app icon (badge) or clears it if the number is 0 or less.
 *
 * Requires a permission from the user to show notifications (asked automatically).
 * Only works with some Android launchers.
 */
import { Badge } from '@capawesome/capacitor-badge';
import { isApplicationRunningOnAndroid } from 'acscp/components/common/helpers/isApplicationRunningOnAndroid';

export function setAppBadgeNumber(n: number): void {
    Badge.isSupported()
        .then(res => {
            // On Android devices there is a bug where the badge number can only update while the app is running.
            // See IBOSCI-350. To work around this issue, we want to restore the default OneSignal behaviour - that
            // the badge number matches the number of open notifications. Consequently, we do not manually set the
            // badge number for Android devices anymore.
            if (res.isSupported && !isApplicationRunningOnAndroid()) {
                if (n > 0) {
                    void Badge.set({count: n});
                } else {
                    void Badge.clear();
                }
            }
        });
}
